import React from "react";

import { Users } from "lucide-react";

import PageHeader from "../../Components/PageHeader";
import CoverageReturnBanner from "../CoverageAnalysis/CoverageReturnBanner";
import TeamViewsShell from "../Relationship/team-views/TeamViewsShell";

/**
 * Standalone Team Views page. Height lock is page-local so V3 keeps an
 * internal scroll pane (sticky chrome / magnetic chips) without changing
 * RoleBasedLayout for other routes.
 */
const TeamViewsPage: React.FC = () => (
  <div className="mt-3 flex h-[calc(100%-0.75rem)] min-h-0 flex-col overflow-hidden bg-white">
    <PageHeader
      className="shrink-0"
      title="Team Views"
      icon={Users}
      breadcrumb={[]}
      subTitle="Roster coverage by person and by account."
    />
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-3 md:p-4">
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-md bg-gray-100 p-4">
        <CoverageReturnBanner />
        <TeamViewsShell />
      </div>
    </div>
  </div>
);

export default TeamViewsPage;
